import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/mockyeah-docs/src/layouts/default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "suites",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#suites",
        "aria-label": "suites permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Suites`}</h1>
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` provides the ability to capture request/responses and play them back later as mock services.
While recording, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeah`}</code>{` proxies all received requests to configured hosts and captures their responses.
Suites include: response body, method, headers, status code, latency, and path.`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-server/API/record"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`record`}</code></a>{`, `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-server/API/recordStop"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`recordStop`}</code></a>{`, and `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-server/API/play"
      }}><code parentName="a" {...{
          "className": "language-text"
        }}>{`play`}</code></a>{`.`}</p>
    <p>{`See also our section on the `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-cli"
      }}>{`CLI`}</a>{`
for another way to record and play.`}</p>
    <h2 {...{
      "id": "ad-hoc-suites",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#ad-hoc-suites",
        "aria-label": "ad hoc suites permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ad Hoc Suites`}</h2>
    <p>{`Suites can be created manually. This can ease the repetitive setup of multiple
services. Here are the steps to creating ad hoc suites:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create a suite directory (e.g. `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`./mockyeah/suite-example`}</code>{`)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add one or more files containing, at minimum, the following:`}</p>
      </li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}>{`module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`
    `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'/some/service'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      text`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'Hello world!'`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Play your ad hoc suites.`}</li>
    </ol>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'@mockyeah/server'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`play`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'suite-example'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`Or play all:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "js"
    }}><pre parentName="div" {...{
        "className": "language-js"
      }}><code parentName="pre" {...{
          "className": "language-js"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'@mockyeah/server'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`playAll`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span></code></pre></div>
    <p>{`That's it!`}</p>
    <h2 {...{
      "id": "dynamic-suites",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#dynamic-suites",
        "aria-label": "dynamic suites permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Dynamic Suites`}</h2>
    <p>{`Without mounting suites explicitly via `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`play`}</code>{` or `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`playAll`}</code>{`, you can dynamically opt-in to them
using our custom HTTP header `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`x-mockyeah-suite`}</code>{`, or custom cookie `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`mockyeahSuite`}</code>{`,
with a value equal to the name of a suite in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`suitesDir`}</code>{` from `}<a parentName="p" {...{
        "href": "../Packages/mockyeah-server/Configuration"
      }}>{`configuration`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      